import { CONTROLLER_NAMES } from "../../../data/Constant";

export const Menu = [
    {
        id: [CONTROLLER_NAMES.User, CONTROLLER_NAMES.Roles],
        icon: "solar:users-group-two-rounded-bold",
        name: "usersManagement",
        path: "/usersManagement",
        isallowedForSuperAdmin:true ,
        children: [{
            id: CONTROLLER_NAMES.User,
            icon: "fa-user-shield",
            path: "/users",
            name: "Users"
        },
        {
            id: CONTROLLER_NAMES.Roles,
            icon: "fa-user-tag",
            path: "/roles",
            name: "Roles"
        }]
    },
    {
        id: [CONTROLLER_NAMES.ProviderRegistrationRequest],
        icon: "mdi:partnership-outline",
        path: "/providers-request",
        name: "providers-request",
        isallowedForSuperAdmin:true ,
    },
    {
        id: [CONTROLLER_NAMES.HospitalProfile],
        icon: "healthicons:virus-patient",
        path: "/provider-profile",
        name: "provider-profile",
        isallowedForSuperAdmin:false ,
    },
    {
        id: [CONTROLLER_NAMES.Doctors],
        icon: "healthicons:doctor-male",
        path: "/provider/doctors",
        name: "doctors",
        isallowedForSuperAdmin:false ,

        
    },
    {
        id: [CONTROLLER_NAMES.PatientRequest],
        icon: "carbon:reminder-medical",
        path: "/provider/requests/medical",
        name: "patient-request",
        isallowedForSuperAdmin:false ,

    },
     {
        id: [CONTROLLER_NAMES.BrokerReportsGroup],
        icon: "streamline-cyber:group-refresh",
        path: "/broker/clients/report",
        name: "broker-clients-report",
        isallowedForSuperAdmin:false ,

    },
    {
        id: [CONTROLLER_NAMES.BrokerMedicalRequests],
        icon: "ri:group-2-line",
        path: "/broker/medical-requests",
        name: "broker-medical-requests",
        isallowedForSuperAdmin:false ,

    },
  
    {
        id: [CONTROLLER_NAMES.AccountManagerRequests],
        icon: "icon-park-outline:table-report",
        path: "/account-manager/medical-reports",
        name: "account-manager-reports",
        isallowedForSuperAdmin:false ,

    },
    {
        id: [CONTROLLER_NAMES.AccountManagerRequests],
        icon: "ri:group-2-line",
        path: "/account-manager/medical-requests",
        isallowedForSuperAdmin:false ,
        name: "account-manager-requests",
    },
]